import { z } from "zod";

const positiveQuantity = z.number().int().positive();
const isoDateString = z.string().refine(value => !Number.isNaN(Date.parse(value)), "Must be a valid date");

export const orderCreateSchema = z.object({
  listingId: z.string().min(1),
  buyerId: z.string().min(1),
  quantity: positiveQuantity,
  paymentMethodId: z.string().min(1),
});

export const bidCreateSchema = z.object({
  listingId: z.string().min(1),
  buyerId: z.string().min(1),
  unitPrice: z.number().positive(),
  quantity: positiveQuantity,
  expiresAt: isoDateString,
});

export const holdRequestSchema = z.object({
  listingId: z.string().min(1),
  buyerId: z.string().min(1),
  quantity: positiveQuantity,
  holdHours: z.number().int().min(1).max(72),
});

export const disputeCreateSchema = z.object({
  orderId: z.string().min(1),
  reason: z.string().min(5),
  details: z.string().optional(),
});

export type OrderCreateInput = z.infer<typeof orderCreateSchema>;
export type BidCreateInput = z.infer<typeof bidCreateSchema>;
export type HoldRequestInput = z.infer<typeof holdRequestSchema>;
export type DisputeCreateInput = z.infer<typeof disputeCreateSchema>;
